import IconX from '!svg-react-loader?!images-react-svg/icons/icon-x.svg';

import React from 'react';
import ReactModal from 'react-modal';
import classNames from 'classnames';

import propTypes from 'prop-types';
import { toggleScrollLock } from 'common/utils';

const MODAL_CONTENT_CLASSNAME = 'Modal__content';
export const MODAL_CONTENT_SELECTOR = `.${MODAL_CONTENT_CLASSNAME}`;

export default class Modal extends React.Component {
  static propTypes = {
    // Uses react-modal props.
    // See https://github.com/reactjs/react-modal
    bodyClassName: propTypes.string,
    style: propTypes.object,
    className: propTypes.string,
    closable: propTypes.bool,
    isOpen: propTypes.bool,
  };

  static defaultProps = {
    closable: true,
    canScrollLock: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      isOpen: this.props.isOpen,
      isScrollLocked: false,
    };
  }

  closeModal = (triggerOnRequestClose = true) => {
    if (!this.props.closable) {
      return;
    }

    toggleScrollLock(MODAL_CONTENT_SELECTOR, false);
    this.setState({ isOpen: false });

    if (triggerOnRequestClose) {
      this.props.onRequestClose && this.props.onRequestClose();
    }
  };

  handleAfterOpen = () => {
    toggleScrollLock(MODAL_CONTENT_SELECTOR, true);
    this.props.onAfterOpen && this.props.onAfterOpen();
  };

  componentWillUnmount = () => {
    if (this.props.isOpen) {
      toggleScrollLock(MODAL_CONTENT_SELECTOR, false);
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.isOpen && !nextProps.isOpen) {
      this.closeModal(false);
    }
  }

  render() {
    const {
      bodyClassName,
      className,
      overlayClassName,
      closable,
      style,
      ...props
    } = this.props;

    const { isOpen } = this.state;

    return (
      <ReactModal
        className={classNames(MODAL_CONTENT_CLASSNAME, className)}
        overlayClassName={classNames('Modal', overlayClassName)}
        style={style}
        onRequestClose={this.closeModal}
        isOpen={isOpen}
        onAfterOpen={this.handleAfterOpen}
        {...props}
      >
        {closable && (
          <div className="Modal__closer-circle" onClick={this.closeModal}>
            <IconX height="13" width="13" />
          </div>
        )}
        <div className={classNames('Modal__body', bodyClassName)}>
          {this.props.children}
        </div>
      </ReactModal>
    );
  }
}
